// 活动日历
const activityDateList = 'activity/monthlyTable';
// 活动列表
const activityList = 'activity/list';
// 活动详情
const activityInfo = 'activity/details';
export {
  activityDateList,
  activityList,
  activityInfo
}